<template>
    <div class="container-feedback">
        <MpNavbar active="staff" />
        <MpTitle title="员工管理" intro="添加和删除员工权限" />
        <div class="content-table" v-show="tableData">
            <!-- height="300" :loading="loading" -->
            <vxe-toolbar>
                <template #buttons>
                    <!-- <vxe-button @click="reflash">刷新</vxe-button> -->
                    <!-- 筛选level -->
                    <vxe-select v-model="level" placeholder="权限" style="width:120px">
                        <vxe-option label="全部" :value="null"></vxe-option>
                        <!-- <vxe-option label="系统管理员" :value="100"></vxe-option> -->
                        <vxe-option label="管理员" :value="90"></vxe-option>
                        <vxe-option label="员工" :value="80"></vxe-option>
                    </vxe-select>
                    <!-- 搜索用户名输入框和搜索按钮 -->
                    <vxe-input v-model="search" class="my-search" placeholder="搜索用户名" clearable
                        style="margin-left:10px; width:200px" @keydown.enter.native="searchUser()">
                    </vxe-input>
                    <vxe-button @click="searchUser()">搜索</vxe-button>

                </template>
            </vxe-toolbar>
            <vxe-table round border highlight-hover-row resizable ref="xTable" :data="tableData">
                <vxe-table-column type="seq" width="60"></vxe-table-column>
                <!-- <vxe-table-column field="id" title="ID" width="60"></vxe-table-column> -->
                <vxe-table-column field="createTime" :formatter="formatTime" title="注册时间"></vxe-table-column>
                <vxe-table-column field="nickname" title="用户">
                    <template #default="{ row, rowIndex }">
                        <!-- 头像昵称 -->
                        <div class="flex-row">
                            <!-- 有头像 -->
                            <div class="flex-row-item" v-if="row && row.avatar">
                                <img v-if="row.avatar.indexOf('http') > -1" :src="row.avatar"
                                    style="width: 30px; height: 30px; border-radius: 50%;" />
                                <img v-if="row.avatar.indexOf('http') == -1" :src="'https://webapi.giiloo.com' + row.avatar"
                                    style="width: 30px; height: 30px; border-radius: 50%;" />
                            </div>
                            <!-- 无头像 -->
                            <!-- <div class="flex-row-item" v-else>
                                <img src="https://webapi.giiloo.com/images/avatar/6952d39098aa4d07ad25eab8a4835abef.png"
                                    style="width: 30px; height: 30px; border-radius: 50%;" />
                            </div> -->
                            <div class="flex-row-item" style="margin-left: 10px;">
                                <div>{{ row.nickname }}</div>
                                <div style="font-size: 12px; color: #999;">{{ row.username }}</div>
                            </div>
                        </div>
                    </template>
                </vxe-table-column>
                <vxe-table-column field="level" title="权限" :formatter="formatLevel"></vxe-table-column>
                <vxe-table-column title="操作" width="170">
                    <template #default="{ row, rowIndex }">
                        <van-button v-if="row.level == 80" color="#13ACA7" size="small" round
                            @click="setAdmin(row)">设为管理员</van-button>
                        <van-button v-if="row.level == 0 || row.level == 90" color="#489D80" size="small" round
                            @click="setStaff(row)">设为员工</van-button>
                        <van-button v-if="row.level >= 80" style="margin-left: 6px;" color="#FD4343" size="small" round
                            @click="setUser(row)">移除员工</van-button>
                    </template>
                </vxe-table-column>
            </vxe-table>
            <vxe-pager background size="small" :loading="loading" :current-page="tablePage.currentPage"
                :page-size="tablePage.pageSize" :total="tablePage.totalResult" :page-sizes="[10, 20, 100]"
                :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
                @page-change="handlePageChange">
            </vxe-pager>
        </div>
    </div>
</template>
  
<script>
import MpNavbar from '../../components/mp/navbar'
import MpTitle from '../../components/mp/title'
import { apiUser, apiSetAdmin, apiSetStaff, apiSetUser } from '../../request/api'
import { Toast } from 'vant';

export default {
    components: {
        MpNavbar,
        MpTitle
    },
    name: 'Index',
    // props: {
    //   msg: String
    // },
    data() {
        return {
            loading: false,
            tableData: null,
            tablePage: {
                currentPage: 1,
                pageSize: 10,
                totalResult: null,
            },
            search: null,
            level: 80,
        }
    },
    filters: {},

    watch: {
        level() {
            this.reflash()
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {
            this.getUser()
        },
        searchUser () {
            this.level = null
            this.reflash()
        },
        reflash() {
            this.tablePage = {
                currentPage: 1,
                pageSize: 10,
                totalResult: null
            }
            this.tableData = null
            this.getUser()
        },
        getUser() {
            let self = this
            self.loading = true
            let params = {
                page: self.tablePage.currentPage,
                size: self.tablePage.pageSize,
            }
            if (this.search) {
                params.search = this.search
            }
            if (this.level) {
                params.level = this.level
            }
            apiUser(params).then(res => {
                self.tableData = res.data.rows
                self.tablePage.totalResult = res.data.count
                self.loading = false
            }).catch(err => {
                console.log(err)
                self.loading = false
            })
        },
        setStaff(row) {
            let self = this
            let params = {
                uuid: row.uuid,
                level: 80
            }
            apiSetStaff(params).then(res => {
                console.log(res)
                if (res.code == 0) {
                    Toast({
                        message: "设置成功",
                    })
                }
                self.reflash()
            }).catch(err => {
                console.log(err)
            })
        },
        setAdmin(row) {
            let self = this
            let params = {
                uuid: row.uuid,
                level: 90
            }
            apiSetAdmin(params).then(res => {
                console.log(res)
                Toast({
                    message: "设置成功",
                })
                self.reflash()
            }).catch(err => {
                console.log(err)
            })
        },
        setUser(row) {
            let self = this
            let params = {
                uuid: row.uuid,
                level: 0
            }
            apiSetUser(params).then(res => {
                console.log(res)
                Toast({
                    message: "设置成功",
                })
                self.reflash()
            }).catch(err => {
                console.log(err)
            })
        },
        handlePageChange({ currentPage, pageSize }) {
            this.tablePage.currentPage = currentPage
            this.tablePage.pageSize = pageSize
            this.getUser()
        },
        formatTime({ cellValue, row, column }) {
            let time = new Date(cellValue)
            let year = time.getFullYear()
            let month = time.getMonth() + 1
            let date = time.getDate()
            let hours = time.getHours()
            let minute = time.getMinutes()
            let second = time.getSeconds()

            if (month < 10) { month = '0' + month }
            if (date < 10) { date = '0' + date }
            if (hours < 10) { hours = '0' + hours }
            if (minute < 10) { minute = '0' + minute }
            if (second < 10) { second = '0' + second }
            return year + '.' + month + '.' + date + ' ' + hours + ':' + minute
        },
        formatLevel({ cellValue, row, column }) {
            if (cellValue == 100) {
                return '系统管理员'
            } else if (cellValue == 90) {
                return '管理员'
            } else if (cellValue == 80) {
                return '员工'
            } else if (cellValue == 0) {
                return '用户'
            } else {
                return '未知'
            }
        },
        exportDataEvent() {
            this.$refs.xTable.exportData({
                filename: '用户反馈',
                sheetName: 'Sheet1',
                type: 'xlsx'
            })
        },
        go(where) {
            this.$router.push('/' + where)
        },
    }
}
</script>
  
<style scoped>
.container-feedback {
    width: 100%;
    height: 100%;
    overflow: auto;
    position: relative;
    padding-left: 110px;
    padding-top: 30px;
    padding-right: 30px;
    padding-bottom: 30px;
}

/* 头像昵称 */
.flex-row {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.flex-row-item {}
</style>